/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-accountant-leave-dialog .blue-dialog .k-content.k-window-content.k-dialog-content{color:#fff}"];
export { styles as styles };
